import React from "react";
import { Info } from "lucide-react";
import { termOf } from "../lib/glossary";

// Hover tooltip. Pass `text` directly, or `term` to look it up in the glossary.
export default function Hint({ text, term, children, className = "" }) {
  const content = text || termOf(term) || null;
  return (
    <span className={`relative inline-flex items-center group ${className}`}>
      {children}
      {content && <Info size={12} className="ml-1 text-slate-300 group-hover:text-brand-500 cursor-help shrink-0" />}
      {content && (
        <span className="pointer-events-none absolute left-1/2 -translate-x-1/2 bottom-full mb-1.5 w-max max-w-[230px] rounded-lg bg-slate-900 text-white text-[11px] leading-snug px-2.5 py-1.5 opacity-0 group-hover:opacity-100 transition-opacity duration-150 z-[60] shadow-lg normal-case tracking-normal font-normal text-left whitespace-normal">
          {content}
        </span>
      )}
    </span>
  );
}
